import {
  formSettingsParams,
  FormSettingsParams,
} from '../../components-shared/Settings/FormDesign/settingsParams'
import {SettingsParamsType} from '../../types/createStylesParams'

import {displaySettingsParams, DisplaySettingsParams} from './Settings/Tabs/Display/settingsParams'
import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'

export type SettingsParams = DisplaySettingsParams & FormSettingsParams & TextsSettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...formSettingsParams,
  ...displaySettingsParams,
  ...textsSettingsParams,
}

export default settingsParams
